import { render, staticRenderFns } from "./documenting.vue?vue&type=template&id=496a10f8&scoped=true"
import script from "./documenting.vue?vue&type=script&lang=js"
export * from "./documenting.vue?vue&type=script&lang=js"
import style0 from "./documenting.vue?vue&type=style&index=0&id=496a10f8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a10f8",
  null
  
)

export default component.exports